import { getStringAttributeValue } from '../../../util'
import { Maybe, ProductInterface } from '@pylot-data/fwrdschema'
import { PylotFrontendConfig } from 'config'

/**
 * @see https://schema.org/gtin
 * Gtin attribute may have a variable length, and it's name is based on that length
 *
 * @param product
 */
export const getGtin = (
    product: ProductInterface,
    config: PylotFrontendConfig
): Maybe<Record<string, string>> => {
    const gtin = getStringAttributeValue(product, 'gtin', config)
    const allowedGtinLength = [8, 12, 13, 14]
    return gtin && allowedGtinLength.includes(gtin.length)
        ? { [`gtin${gtin.length}`]: gtin }
        : {}
}
